<template>
    <div class="contract-field" :class="{'contract-field--bar':showBar}">
        <editor-menu-bar v-if="showBar" :editor="editor" v-slot="{ commands }">
            <div class="df df--space-between mb8">
                <h2 class="text-size-ml text-bold mt0 mb0 df">{{ barTitle }}</h2>
                <span :class="{'is-active': editor.isActive.bold() && contractFocus }" class="editor-btn has-hint" @click="commands.bold">
                        <span class="i-wrapper">
                            <span class="i i-bold"></span>
                        </span>
                        <span class="hint bottom-center-direction">Жирный</span>
                    </span>
            </div>
        </editor-menu-bar>

        <div @click="setFocus()"><editor-content :class="{'pseudo-textarea--focus':contractFocus && showBar}" @keydown.native.enter.stop.prevent="addItem()" @keydown.native.delete="deleteItem" class="pseudo-textarea" :editor="editor" /></div>
    </div>
</template>


<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
    HardBreak,
    Bold,
    Placeholder,
} from 'tiptap-extensions'
import NoBreak from '@/components/editor/tiptop/NoBreak.js';
export default {
    name: "EditableItem",
    props: {
        value: {
            default: ''
        },
        showBar: {default: false},
        barTitle: {default: ''},
        placeholder: {default: 'Введите текст...'},
        inputId: {default: ''},
        disabled: {default: false},
        autoFocus: {default: true},
        noBreak: {default: false},
    },
    components: {
        EditorContent,
        EditorMenuBar,
    },
    mounted(){
        this.updateContent();
    },
    data() {
        return {
            editor: new Editor({
                extensions: [
                    new Bold(),
                    (this.noBreak ? new NoBreak() : new HardBreak()),
                    new Placeholder({
                        emptyEditorClass: 'is-editor-empty',
                        emptyNodeClass: 'is-empty',
                        emptyNodeText: this.placeholder,
                        showOnlyWhenEditable: true,
                        showOnlyCurrent: true,
                    }),
                ],
                autoFocus: this.autoFocus,
                onUpdate: ({ getJSON, getHTML }) => {
                    this.$emit('input',getHTML())
                },
                onFocus: () => {
                    this.contractFocus = true;
                    this.$emit('focus',this.editor);

                },
                onBlur: () => {
                    this.contractFocus = false;
                    this.$emit('blur');

                },
            }),
            contractFocus: false,
        }
    },
    methods: {
        setFocus(){
            if(!this.contractFocus){
                this.editor.focus();
            }
        },
        addItem(){
            this.$emit('push');
        },
        deleteItem(e){
            if(e.target.innerHTML == '<p data-empty-text="'+this.placeholder+'" class="is-empty is-editor-empty"><br class="ProseMirror-trailingBreak"></p>'){
                this.$emit('delete');
            }
        },
        bold(){
            this.editor.commands.bold()
        },
        updateContent(){
            this.$nextTick(()=>{
                this.editor.setContent(this.value.replace(/(?:\r\n|\r|\n)/g, '<br />'),true)
            })
        }
    },
}
</script>

<style>
    .contract-field  {
        width: 100%;
    }
    .pseudo-textarea--focus{
        background-color: #fff;
        border-color: #2F80ED;
    }
    .contract-field p.is-editor-empty:first-child::before {
        font-size: 16px;
        line-height: 17px;
        opacity: 0.5;
        content: attr(data-empty-text);
        float: left;
        pointer-events: none;
        height: 0;
    }
    .contract-field--bar p.is-editor-empty:first-child::before {
        font-size: 14px;
    }
    .contract-field .ProseMirror{
        overflow: hidden;
    }
</style>
